import { render } from "./ExactAge.vue?vue&type=template&id=657cb7ee&scoped=true&ts=true"
import script from "./ExactAge.vue?vue&type=script&lang=ts"
export * from "./ExactAge.vue?vue&type=script&lang=ts"

import "./ExactAge.vue?vue&type=style&index=0&id=657cb7ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\yearchecker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657cb7ee"]])

export default __exports__